import { theme } from 'antd'
import './LoadingAnimation.css'

export function LoadingAnimation({ center, style }) {
  const { token } = theme.useToken()
  let centerProps = {}
  if (center) {
    centerProps = {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      margin: 0,
    }
  }
  return (
    <div style={{ color: token.colorPrimary, ...style, ...centerProps }}>
      <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}
